export default __webpack_public_path__ + "static/media/close_button.f5e57628.png";